export default __webpack_public_path__ + "static/media/low-meter.5360c9f5.svg";